class Api {
  
    
    
    constructor(apiUrl) {
      this.url = apiUrl;
    }
    
    send(
      uri,
      json, 
      successCallback, 
      errorCallback
    ) {
      $.ajax({
             url: this.url + uri,
             type: "post",
             data: json ,
             success: function (response) {
                successCallback(response);
             },
             error: function(jqXHR, textStatus, errorThrown) {
                errorCallback(jqXHR, textStatus, errorThrown);
             }
         });
    }
    
  }
  export default Api;
  


//////////////////
// WEBPACK FOOTER
// ./src/games/dog-racing/js/api/api.js
// module id = 156
// module chunks = 11